const MILLISECOND = 1;
const SECOND = MILLISECOND * 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

const TRANSLIT = {
  en: {
    'q': 'й',
    'w': 'ц',
    'e': 'у',
    'r': 'к',
    't': 'е',
    'y': 'н',
    'u': 'г',
    'i': 'ш',
    'o': 'щ',
    'p': 'з',
    'a': 'ф',
    's': 'ы',
    'd': 'в',
    'f': 'а',
    'g': 'п',
    'h': 'р',
    'j': 'о',
    'k': 'л',
    'l': 'д',
    'z': 'я',
    'x': 'ч',
    'c': 'с',
    'v': 'м',
    'b': 'и',
    'n': 'т',
    'm': 'ь',
    '{': 'х',
    '[': 'х',
    '}': 'ъ',
    ']': 'ъ',
    ':': 'ж',
    ';': 'ж',
    '\'': 'э',
    '"': 'э',
    ',': 'б',
    '.': 'ю',
    '/': '.'
  },
  ru: {
    'й': 'q',
    'ц': 'w',
    'у': 'e',
    'к': 'r',
    'е': 't',
    'н': 'y',
    'г': 'u',
    'ш': 'i',
    'щ': 'o',
    'з': 'p',
    'ф': 'a',
    'ы': 's',
    'в': 'd',
    'а': 'f',
    'п': 'g',
    'р': 'h',
    'о': 'j',
    'л': 'k',
    'д': 'l',
    'я': 'z',
    'ч': 'x',
    'с': 'c',
    'м': 'v',
    'и': 'b',
    'т': 'n',
    'ь': 'm',
    'х': '[',
    'ъ': ']',
    'ж': ':',
    'э': '"',
    'б': ',',
    'ю': '.',
    '.': '/'
  }
};
// eslint-disable-next-line no-useless-escape
const EN_REGEX = /^[~`!@#$%^&*()_ +=[\]\\{}|;':",.\/<>?a-zA-Z0-9-]+$/;
// eslint-disable-next-line no-useless-escape
const RU_REGEX = /^[~`!@#$%^&*()_ +=[\]\\{}|;':",.\/<>?а-яА-ЯЁё0-9-]+$/;

class RowFactory {
  /** @returns Extended class with row functionality */
  static create(Entity) {
    class Row extends Entity {
      constructor() {
        super(...arguments);
        this.disabled = false;
        this.expanded = false;
        this.mountKey = 1;
      }
      get isExpanded() {
        return this.expanded;
      }
      get isDisabled() {
        return this.disabled;
      }
      get updateKey() {
        return this.mountKey;
      }
      switchExpanded() {
        this.expanded = !this.expanded;
      }
      expand() {
        this.expanded = true;
      }
      collapse() {
        this.expanded = false;
      }
      disable() {
        this.disabled = true;
      }
      enable() {
        this.disabled = false;
      }
    }
    return Row;
  }
  /** @returns Extended object with row functionality */
  static extend(object) {
    return Object.defineProperties(object, {
      expanded: {
        value: false,
        writable: true
      },
      disabled: {
        value: false,
        writable: true
      },
      mountKey: {
        value: false,
        writable: true
      },
      isExpanded: {
        get: function () {
          return this.expanded;
        }
      },
      isDisabled: {
        get: function () {
          return this.disabled;
        }
      },
      updateKey: {
        get: function () {
          return this.mountKey;
        }
      },
      switchExpanded: {
        value: function () {
          this.expanded = !this.expanded;
        }
      },
      expand: {
        value: function () {
          this.expanded = true;
        }
      },
      collapse: {
        value: function () {
          this.expanded = false;
        }
      },
      disable: {
        value: function () {
          this.disabled = true;
        }
      },
      enable: {
        value: function () {
          this.disabled = false;
        }
      }
    });
  }
}

class ListFactory {
  static create(Entity, items) {
    return items.map(item => new Entity(item));
  }
  static createRows(Entity, items, options = {}) {
    const RowClass = RowFactory.create(Entity);
    return items.map(item => {
      if (options && options.processFunc) return options.processFunc(new RowClass(item));
      return new RowClass(item);
    });
  }
  static createRowsExtends(items, options = {}) {
    return items.map(item => {
      if (options && options.processFunc) return options.processFunc(RowFactory.extend(item));
      return RowFactory.extend(item);
    });
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function isArray(value) {
  return !!value && value.constructor.name === 'Array';
}
function isValidArray(value) {
  return isArray(value) && !!value.length;
}

function isNotNull(value) {
  return value !== null && value !== undefined;
}
function isFalsy(value) {
  return !isNotNull(value) || Number.isNaN(value) || value === '';
}

const Config = {
  money: {
    maximumFractionDigits: 0,
    fallbackCurrency: 'RUB'
  },
  localeWrapper: {
    fallbackLocale: 'ru'
  }
};

class LocaleWrapper {
  static localeToIntl(locale) {
    return Object.keys(this.replacements).some(key => key === locale) ? this.replacements[locale] : locale;
  }
  static get locale() {
    var _a;
    return this.localeToIntl(((_a = globalThis.$locale) === null || _a === void 0 ? void 0 : _a.value) || Config.localeWrapper.fallbackLocale);
  }
}
LocaleWrapper.replacements = {
  kg: 'ky',
  ch: 'zh'
};

/**
 * @param date - Process date
 * @param format - Format for month name ('March', 'Mar', '03')
 * @param locale - Format language
 * @returns The month name for the given date in the selected format
 * */
function getMonthName(date, format = 'long', locale = 'ru') {
  return new Intl.DateTimeFormat(locale, {
    month: format
  }).format(date);
}
/**
 * @param date - Process date
 * @param format - Format for weekday
 * @param locale - Format language
 * @returns The weekday name for given date in seleectd format
 */
function getWeekdayName(date, format = 'long', locale = 'ru') {
  return new Intl.DateTimeFormat(locale, {
    weekday: format
  }).format(date);
}
/**
 * Function for working with Intl DateTimeFormat
 * @param date - Process date
 * @param options - Options for Intl DateTimeFormat formatter
 * @param [locale='ru']
 * @returns Object with date parts (year, month, etc.)
 */
function getDateParts(date, options = {}, locale = 'ru') {
  const parts = new Intl.DateTimeFormat(locale, options).formatToParts(date);
  return parts.reduce((acc, item) => {
    const key = item.type;
    acc[key] = item.value;
    return acc;
  }, {});
}
function isLessThenYesterday(date) {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return date < yesterday;
}
function addZero(value) {
  return `${value}`.padStart(2, '0');
}
function date02format(value) {
  if (Number.isInteger(value)) {
    if (value < 10 && value >= 0) return `0${value}`;
    if (value < 0 && value > -10) return `-0${`${value}`.substring(1)}`;
  }
  return `${value}`;
}
function getTimeInSeconds() {
  return Math.floor(Date.now() / 1000);
}
function getFirstDayInMonth(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth();
  return new Date(year, month, 1, 0, 0, 0, 0);
}
function getLastDayInMonth(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return new Date(year, month, 0, 0, 0, 0, 0);
}
function getMonthDateRange(date = new Date()) {
  const from = getFirstDayInMonth(date);
  const to = getLastDayInMonth(date);
  return {
    from,
    to
  };
}
function timeFormat(date) {
  return `${addZero(date.getHours())}:${addZero(date.getMinutes())}`;
}
/**
 * @param dateString - Date in string format
 * @param options
 * @returns Date object
 */
function stringToDate(dateString, options = {}) {
  const splitted = dateString.split(options.sep || ' ');
  const datePart = splitted[0];
  const timePart = splitted[1] || '00:00';
  const [hoursPart, minutesPart] = timePart.split(':');
  const [yearPart, monthPart, dayPart] = datePart.split('-');
  const year = Number(yearPart);
  const month = Number(monthPart) - 1;
  const day = Number(dayPart);
  const hours = Number(hoursPart);
  const minutes = Number(minutesPart);
  return new Date(year, month, day, hours, minutes);
}
/**
 * @param date - Date to process
 * @param format - String like 'DD.MM.YYYY'
 * @returns Date in string format
 */
function dateToString(date, format = 'DD.MM.YYYY') {
  if (!(date instanceof Date)) return '';
  const year = date.getFullYear();
  const month = addZero(date.getMonth() + 1);
  const _date = addZero(date.getDate());
  const hours = addZero(date.getHours());
  const minutes = addZero(date.getMinutes());
  const seconds = addZero(date.getSeconds());
  return format.replace(/DD/, _date).replace(/MM/, month).replace(/YYYY/, `${year}`).replace(/(HH|hh)/, hours).replace(/mm/, minutes).replace(/ss/, seconds);
}
function secondsToPrettyString(seconds = 0) {
  const milliseconds = seconds * 1000;
  const days = Math.floor(milliseconds / DAY);
  const hours = Math.floor(milliseconds % DAY / HOUR);
  const minutes = Math.floor(milliseconds % HOUR / MINUTE);
  const _seconds = Math.floor(milliseconds % MINUTE / SECOND);
  let result = '';
  result += days > 0 ? `${addZero(days)}:` : '';
  result += hours > 0 ? `${addZero(hours)}:` : '';
  result += minutes >= 0 ? `${addZero(minutes)}:` : '';
  result += `${addZero(_seconds)}`;
  return result;
}
function unixToString(unixTime) {
  const h = Math.floor(unixTime / 3600);
  const m = Math.floor(unixTime / 60 - h * 60);
  const fixedMin = m.toString().length === 1 ? `0${m}` : m;
  if (h === 0) return `${fixedMin} мин`;
  if (m === 0) return `${h}ч`;
  return `${h}ч ${fixedMin} мин`;
}
function isDate(value) {
  return value instanceof Date && Object.prototype.toString.call(value) === '[object Date]';
}
function isValidDate(value) {
  return isDate(value) || typeof value === 'string' && !isNaN(stringToDate(value).getTime());
}
function timezoneFormat(utc) {
  const string = `${date02format(utc)}:00`;
  if (utc > 0) return `+${string}`;
  return string;
}
function transformDateToObject(inputDate, options = {}) {
  const result = {
    year: '',
    month: '',
    date: '',
    day: '',
    hour: '',
    minute: '',
    second: '',
    weekday: '',
    time: ''
  };
  if (!isDate(inputDate) && typeof inputDate !== 'string') return result;
  const _options = Object.assign({
    formatterOptions: {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
      weekday: 'long',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }
  }, options);
  const locale = _options.locale || LocaleWrapper.locale;
  const date = typeof inputDate === 'string' ? new Date(inputDate.replace(/-/g, '/')) : inputDate;
  const formatter = new Intl.DateTimeFormat(locale, _options.formatterOptions);
  const formattedParts = formatter.formatToParts(date);
  formattedParts.forEach(part => {
    if (!Object.hasOwn(result, part.type)) return;
    result[part.type] = part.value;
  });
  result.date = `${date.getDate()}`;
  result.day = `${date.getDay()}`;
  result.time = timeFormat(date);
  return result;
}
function dateToDateObject(
// dateToObj
date, options = {}) {
  const result = {
    date: '',
    month: {
      value: '',
      label: ''
    },
    year: NaN,
    isValid: false
  };
  if (!date) return result;
  const locale = (options === null || options === void 0 ? void 0 : options.locale) || LocaleWrapper.locale;
  const _date = typeof date === 'string' ? stringToDate(date) : date;
  result.year = _date.getFullYear();
  result.date = addZero(_date.getDate());
  result.month.value = addZero(_date.getMonth() + 1);
  result.month.label = getMonthName(_date, 'long', locale);
  result.isValid = true;
  return result;
}
function dateObjectToDate(dateObject) {
  if (!dateObject || !dateObject.year) return null;
  const {
    year,
    month,
    date
  } = dateObject;
  return new Date(year, Number(month.value) - 1, Number(date), 0, 0);
}
function dateObjectToString(dateObject) {
  if (!dateObject.year || !dateObject.month.value || !dateObject.date) return '';
  return `${dateObject.year}-${dateObject.month.value}-${dateObject.date}`;
}
function stringToDateObject(string) {
  const result = {
    date: '',
    month: {
      value: '',
      label: ''
    },
    year: NaN,
    isValid: false
  };
  if (!string || !string.length) return result;
  const date = new Date(string);
  result.date = addZero(date.getDate());
  result.month.value = addZero(date.getMonth() + 1);
  result.month.label = getMonthName(date, 'long');
  result.year = date.getFullYear();
  result.isValid = true;
  return result;
}

function downloadFileFromUrl(url, name = '') {
  if (!url) return;
  const fileLink = document.createElement('a');
  const fileName = name !== null && name !== void 0 ? name : url.split('/').at(-1);
  fileLink.setAttribute('href', url);
  fileLink.setAttribute('download', fileName);
  fileLink.setAttribute('target', '_blank');
  document.body.appendChild(fileLink);
  fileLink.click();
  requestAnimationFrame(() => document.body.removeChild(fileLink));
}
function downloadFile(file, name = '') {
  const url = window.URL.createObjectURL(file);
  downloadFileFromUrl(url, name);
  window.URL.revokeObjectURL(url);
}

function debounce(func, wait = 0) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = undefined;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
function throttle(func, delay = 0) {
  let isThrottling = false;
  let lastArgs;
  return (...args) => {
    if (isThrottling) return;
    lastArgs = args;
    func.apply(this, lastArgs);
    isThrottling = true;
    setTimeout(() => isThrottling = false, delay);
  };
}
/**
 * A throttle function that uses requestAnimationFrame to limit the rate at which a function is called
 *
 * [Original implementation](https://github.com/alexreardon/raf-schd)
 */
function schd(func) {
  let lastArgs = [];
  let frameId = null;
  const wrapper = (...args) => {
    lastArgs = args;
    if (frameId) return;
    frameId = requestAnimationFrame(() => {
      frameId = null;
      func(...lastArgs);
    });
  };
  wrapper.cancel = () => {
    if (!frameId) return;
    cancelAnimationFrame(frameId);
    frameId = null;
  };
  return wrapper;
}
function asyncFor(start_1, end_1) {
  return __awaiter(this, arguments, void 0, function* (start, end, iterCallback = () => null, chunkSize = 100) {
    let current = start;
    const processChunk = () => __awaiter(this, void 0, void 0, function* () {
      const chunkEnd = Math.min(current + chunkSize, end);
      for (let i = current; i < chunkEnd; i++) {
        iterCallback(i, () => i = end);
      }
      current = chunkEnd;
      if (current < end) {
        return new Promise(resolve => setTimeout(() => resolve(processChunk()), 0));
      }
      return null;
    });
    yield processChunk();
  });
}

function roundToTwoDecimals(value) {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}
function isNumber(value) {
  return typeof value === 'number';
}
function isNumeric(value) {
  return typeof value === 'string' && !isNaN(+value) && !isNaN(parseFloat(value)) && value !== '';
}
/**
 * @param [value] The value to be parsed
 * @param [clearValue=false] Clear the value of non-numeric characters before parsing
 */
function stringToFloat(value, clearValue = false) {
  /* eslint-disable-next-line */
  if (clearValue) value = value.replace(/[^\p{N}\.]/u, '');
  if (typeof value !== 'string' || isNaN(parseFloat(value))) return value;
  return parseFloat(value);
}
/**
 * @param [value] The value to be parsed
 */
function stringToNumber(value) {
  if (!isNumeric(value)) return value;
  return Number(value);
}

function isObject(value) {
  return !isFalsy(value) && typeof value === 'object' && !Array.isArray(value);
}
function isValidObject(value) {
  return isObject(value) && !!Object.keys(value).length;
}
function copyObject(obj) {
  return JSON.parse(JSON.stringify(obj));
}
function deepCopyObject(source, cloneProto = false) {
  if (source instanceof Date) {
    return new Date(source.getTime());
  }
  if (source instanceof Array) {
    return source.reduce((arr, item, i) => {
      arr[i] = deepCopyObject(item);
      return arr;
    }, []);
  }
  if (source instanceof Object) {
    if (cloneProto) return Object.assign(Object.create(Object.getPrototypeOf(source)), source);
    return Object.keys(source).reduce((newObj, key) => {
      newObj[key] = deepCopyObject(source[key]);
      return newObj;
    }, {});
  }
  return source;
}
function compareDeepObject(a, b) {
  if (a === b) return true;
  if (typeof a !== 'object' || typeof b !== 'object' || !a || !b) return false;
  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) return false;
  return aKeys.every(key => {
    if (!Object.hasOwn(b, key)) return false;
    return compareDeepObject(a[key], b[key]);
  });
}
/**
 * @param object - The object from which the property value will be taken
 * @param propString - A string in the format 'prop1.prop2.prop3' or 'prop1.prop2[0].prop3'
 * @returns The value of the final property. undefined if property was not found in object
 */
function getObjectPropByString(object, propString) {
  if (!propString || !object) return null;
  return propString.split('.').reduce((currentObj, prop) => {
    return isObject(currentObj) ? currentObj === null || currentObj === void 0 ? void 0 : currentObj[prop] : currentObj;
  }, object);
}
function removeEmptyFields(object, ignoreBoolean = false) {
  if (!isValidObject(object)) return object;
  return Object.fromEntries(Object.entries(object).filter(([, v]) => !isFalsy(v) || ignoreBoolean && typeof v === 'boolean'));
}

function isString(value) {
  return typeof value === 'string';
}
function isValidString(string) {
  return isString(string) && !isArray(string) && string.length !== 0;
}
function capitalize(string) {
  if (!isValidString(string)) return '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
function plural(count, wordFormsArray) {
  const roundedCount = Math.round(count);
  let wordIndex;
  if (roundedCount % 10 === 1 && roundedCount % 100 !== 11) {
    wordIndex = 0; // one
  } else if (roundedCount % 10 >= 2 && roundedCount % 10 <= 4 && (roundedCount % 100 < 10 || roundedCount % 100 >= 20)) {
    wordIndex = 1; // few
  } else {
    wordIndex = 2; // many
  }
  return wordFormsArray[wordIndex] || '';
}
function convertString(value, lang = 'ru') {
  if (!isString(value)) return '';
  const lettersArray = value.split('');
  return lettersArray.reduce((acc, char) => {
    var _a;
    return acc + (((_a = TRANSLIT[lang]) === null || _a === void 0 ? void 0 : _a[char]) || char);
  }, '');
}
function convertToTranslit(value) {
  const initial = String(value);
  if (EN_REGEX.test(value)) return convertString(value, 'en');
  if (RU_REGEX.test(value)) return convertString(value, 'ru');
  return initial;
}
function toCamelCase(str, options = {}) {
  if (!isString(str) && !isArray(str)) return str;
  if (isArray(str)) return toCamelCase(str.join(' '), options);
  const result = str.trim().replace(/[^\p{L}\p{N}]+(\p{L})/gu, (_, char) => char.toUpperCase());
  return options.pascalCase ? result.charAt(0).toUpperCase() + result.slice(1) : result.charAt(0).toLowerCase() + result.slice(1);
}
function toBase64(str) {
  try {
    return btoa(str);
  } catch (err) {
    return Buffer.from(str, 'binary').toString('base64');
  }
}
function fromBase64(b64Encoded) {
  try {
    return atob(b64Encoded);
  } catch (err) {
    return Buffer.from(b64Encoded, 'base64').toString('binary');
  }
}

function lockScroll(lockClass = 'lock-scroll') {
  document.body.classList.add(lockClass);
}
function unlockScroll(lockClass = 'lock-scroll') {
  document.body.classList.remove(lockClass);
}

var _List_instances, _List_getListItems, _List_listFactoryOptions_get;
class List {
  constructor(data, options = {}) {
    _List_instances.add(this);
    this.list = [];
    this.options = {};
    if (isFalsy(data)) return;
    this.updateOptions(options);
    this.fillList(data);
  }
  /** Updates the current instance settings */
  updateOptions(options) {
    this.options = Object.assign(Object.assign({}, this.options), options);
  }
  /** Fills in the list with the transmitted data. All data processed by ListFactory */
  fillList(listData) {
    if (!isValidArray(listData)) return;
    this.list = __classPrivateFieldGet(this, _List_instances, "m", _List_getListItems).call(this, listData);
  }
  clearList() {
    this.list = [];
  }
  /** Adds a new element to the beginning of the list */
  prependItem(itemData) {
    const [item] = __classPrivateFieldGet(this, _List_instances, "m", _List_getListItems).call(this, [itemData]);
    this.list.unshift(item);
    return item;
  }
  /** Add new items to the end of list */
  addItems(data) {
    if (!isValidArray(data)) return [];
    const items = __classPrivateFieldGet(this, _List_instances, "m", _List_getListItems).call(this, data);
    this.list.push(...items);
    return items;
  }
  /**
   * Deletes item from list array. Total decreases by 1 if element was removed
   * @param [id] Element ID
   * @param [compareProperty='id'] The key of the object for which the Element ID is being compared
   * @return Removed item. Null if item not found
   * */
  removeItem(id, compareProperty = 'id') {
    const index = this.list.findIndex(item => item[compareProperty] === id);
    if (index < 0) return null;
    return this.list.splice(index, 1)[0];
  }
  /**
   * Replaces an item in the list by the specified id
   * @param [id] Element ID
   * @param [item] New element data
   * @param [compareProperty='id'] The key of the object for which the Id is being compared
   * @returns Index of the replaced element
   * */
  replaceItem(id, item, compareProperty = 'id') {
    const index = this.list.findIndex(_item => _item[compareProperty] === id);
    if (index < 0) return -1;
    [this.list[index]] = __classPrivateFieldGet(this, _List_instances, "m", _List_getListItems).call(this, [item]);
    return index;
  }
  get isFilled() {
    return !!this.list && this.list.length > 0;
  }
}
_List_instances = new WeakSet(), _List_getListItems = function _List_getListItems(data) {
  return this.options.ListEntity ? ListFactory.createRows(this.options.ListEntity, data, __classPrivateFieldGet(this, _List_instances, "a", _List_listFactoryOptions_get)) : ListFactory.createRowsExtends(data, __classPrivateFieldGet(this, _List_instances, "a", _List_listFactoryOptions_get));
}, _List_listFactoryOptions_get = function _List_listFactoryOptions_get() {
  return {
    processFunc: this.options.formatRow
  };
};

class Pagination {
  constructor(pagination, options = {}) {
    this.page = 0;
    this.total = 0;
    this.limit = 10;
    this.totalPages = 0;
    this.options = {
      pageProperty: 'page',
      totalProperty: 'total',
      limitProperty: 'limit'
    };
    if (!isValidObject(pagination)) return;
    this.updateOptions(options);
    this.page = pagination[this.options.pageProperty || 'page'];
    this.total = pagination[this.options.totalProperty || 'total'];
    this.limit = pagination[this.options.limitProperty || 'limit'];
    if (!this.limit) this.limit = 0;
    this.totalPages = Math.ceil(this.total / this.limit);
  }
  updateOptions(options) {
    if (!isValidObject(options)) return;
    this.options = Object.assign(Object.assign({}, this.options), options);
  }
  /** Returns the number of items available for the next page in pagination. */
  get availableItemsForNextPage() {
    const itemsLeft = this.total - this.limit * this.page;
    return itemsLeft > this.limit ? this.limit : itemsLeft;
  }
  /**
   * Returns the number of items available for the next page in pagination.
   * @deprecated It will be deleted soon.
   * */
  get nextCount() {
    return this.availableItemsForNextPage;
  }
  get canShowMore() {
    return this.total > this.limit * this.page;
  }
  /** The left limit value of the list */
  get limitStart() {
    if (this.total === 0) return 0;
    return this.page === 1 ? 1 : (this.page - 1) * this.limit + 1;
  }
  /** The right limit value of the list */
  get limitEnd() {
    return this.page >= this.totalPages ? this.total : this.page * this.limit;
  }
  get isPrevDisabled() {
    return this.page <= 1;
  }
  get isNextDisabled() {
    return this.page >= this.totalPages;
  }
}

var _ListWithPagination_instances, _ListWithPagination_getListData, _ListWithPagination_getPaginationData;
class ListWithPagination extends List {
  constructor(data, options) {
    super([]);
    _ListWithPagination_instances.add(this);
    this.pagination = {};
    this.options = {
      listProperty: 'list',
      paginationProperty: 'pagination',
      PaginationEntity: Pagination
    };
    this.updateOptions(options);
    this.fill(data);
  }
  fill(data) {
    const listData = __classPrivateFieldGet(this, _ListWithPagination_instances, "m", _ListWithPagination_getListData).call(this, data);
    const paginationData = __classPrivateFieldGet(this, _ListWithPagination_instances, "m", _ListWithPagination_getPaginationData).call(this, data);
    this.fillList(listData);
    this.fillPagination(paginationData);
  }
  fillPagination(paginationData) {
    if (!isValidObject(paginationData)) return;
    if (this.options.PaginationEntity) {
      this.pagination = new this.options.PaginationEntity(paginationData, this.options.paginationOptions);
      return;
    }
    this.pagination = paginationData;
  }
  addItems(data) {
    const listData = __classPrivateFieldGet(this, _ListWithPagination_instances, "m", _ListWithPagination_getListData).call(this, data);
    const paginationData = __classPrivateFieldGet(this, _ListWithPagination_instances, "m", _ListWithPagination_getPaginationData).call(this, data);
    this.fillPagination(paginationData);
    return super.addItems(listData);
  }
}
_ListWithPagination_instances = new WeakSet(), _ListWithPagination_getListData = function _ListWithPagination_getListData(data) {
  var _a;
  return isValidObject(data) && ((_a = this.options) === null || _a === void 0 ? void 0 : _a.listProperty) && isValidArray(data[this.options.listProperty]) ? data[this.options.listProperty] : data;
}, _ListWithPagination_getPaginationData = function _ListWithPagination_getPaginationData(data) {
  var _a;
  return isValidObject(data) && ((_a = this.options) === null || _a === void 0 ? void 0 : _a.paginationProperty) && isValidObject(data[this.options.paginationProperty]) ? data[this.options.paginationProperty] : {};
};

class LS {
  static get isAvailable() {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }
  static has(key) {
    if (!this.isAvailable) return false;
    return !!this.get(key);
  }
  static set(key, data) {
    if (!this.isAvailable) return;
    const value = JSON.stringify(data);
    localStorage.setItem(key, value);
  }
  static get(key) {
    if (!this.isAvailable) return null;
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }
  static remove(key) {
    if (!this.isAvailable) return;
    localStorage.removeItem(key);
  }
}

var _Money_instances, _Money_currencyValue_get, _Money_numberFormatterLocale_get, _Money_numberFormatterOptions_get;
const LOCALE_BY_CURRENCY = {
  KGS: 'ru-KG',
  kgKGS: 'ru-KG',
  ruKGS: 'ru-KG',
  enKGS: 'ru-US'
};
class Money {
  constructor(value, currency) {
    _Money_instances.add(this);
    if (isString(value)) {
      const formattedValue = stringToFloat(value);
      this.value = isNumber(formattedValue) ? formattedValue : 0;
    } else {
      this.value = isNumber(value) ? value : 0;
    }
    this.currency = currency;
  }
  toString() {
    try {
      const formatter = new Intl.NumberFormat(__classPrivateFieldGet(this, _Money_instances, "a", _Money_numberFormatterLocale_get), __classPrivateFieldGet(this, _Money_instances, "a", _Money_numberFormatterOptions_get));
      return formatter.format(this.value);
    } catch (error) {
      return `${this.value} ${__classPrivateFieldGet(this, _Money_instances, "a", _Money_currencyValue_get)}`;
    }
  }
  toObject() {
    return this;
  }
}
_Money_instances = new WeakSet(), _Money_currencyValue_get = function _Money_currencyValue_get() {
  return this.currency || Config.money.fallbackCurrency;
}, _Money_numberFormatterLocale_get = function _Money_numberFormatterLocale_get() {
  if (__classPrivateFieldGet(this, _Money_instances, "a", _Money_currencyValue_get) !== 'KGS') return LocaleWrapper.locale;
  const key = `${LocaleWrapper.locale}${__classPrivateFieldGet(this, _Money_instances, "a", _Money_currencyValue_get)}`;
  return LOCALE_BY_CURRENCY[key];
}, _Money_numberFormatterOptions_get = function _Money_numberFormatterOptions_get() {
  return {
    style: 'currency',
    currency: __classPrivateFieldGet(this, _Money_instances, "a", _Money_currencyValue_get),
    maximumFractionDigits: Config.money.maximumFractionDigits,
    maximumSignificantDigits: Config.money.maximumSignificantDigits,
    currencyDisplay: Config.money.currencyDisplay
  };
};

class SuperDate {
  /** Input date example: 2024-03-01 00:00:00 */
  constructor(date) {
    this.server = null;
    this.client = null;
    this.server = date;
    // eslint-disable-next-line no-nested-ternary
    this.client = isString(this.server) ? stringToDate(this.server) : date instanceof Date ? date : null;
  }
  isValid() {
    return isNotNull(this.client) && !isNaN(this.client.getTime());
  }
  /** Output example: 1 */
  get day() {
    return this.isValid() ? this.client.getDate() : null;
  }
  /** Output example: '01' */
  get dayTwoSymbols() {
    return this.isValid() ? addZero(this.day) : '00';
  }
  /** Output example: 1 */
  get weekDay() {
    return this.isValid() ? this.client.getDay() : null;
  }
  /** Output example: 'пятница' */
  get longWeekDayName() {
    return this.isValid() ? getWeekdayName(this.client, 'long', LocaleWrapper.locale) : '';
  }
  /** Output example: 'пт' */
  get shortWeekDayName() {
    return this.isValid() ? getWeekdayName(this.client, 'short', LocaleWrapper.locale) : '';
  }
  /** Output example: 3 for March */
  get month() {
    return this.isValid() ? this.client.getMonth() + 1 : null;
  }
  /** Output example: '03' */
  get monthTwoSymbols() {
    return this.isValid() ? addZero(this.month) : '00';
  }
  /** Output example: 'март' */
  get longMonthName() {
    return this.isValid() ? getMonthName(this.client, 'long', LocaleWrapper.locale) : '';
  }
  /** Output example: 'мар' */
  get shortMonthName() {
    return this.isValid() ? getMonthName(this.client, 'short', LocaleWrapper.locale).toLowerCase().substring(0, 3) : '';
  }
  /** Output example: 'марта' */
  get declensionMonthName() {
    return this.isValid() ? getDateParts(this.client, {
      day: 'numeric',
      month: 'long'
    }, LocaleWrapper.locale).month : '';
  }
  /** Output example: 2024 */
  get year() {
    return this.isValid() ? this.client.getFullYear() : NaN;
  }
  /** Output example: '24' */
  get yearTwoSymbols() {
    return this.isValid() ? `${this.year}`.substring(2, 4) : '';
  }
  /** Returns True if the current year matches the specified one. */
  get isCurrentYear() {
    const currentYear = new Date().getFullYear();
    return this.year === currentYear;
  }
  /** Output example: '01.03.24' */
  get date() {
    return this.isValid() ? `${this.dayTwoSymbols}.${this.monthTwoSymbols}.${this.yearTwoSymbols}` : '...';
  }
  /** Output example: '01.03.24 00:00' */
  get dateWithTime() {
    return this.isValid() ? `${this.dayTwoSymbols}.${this.monthTwoSymbols}.${this.yearTwoSymbols} ${this.time}` : '...';
  }
  /** Output example: '01.03' */
  get dateWithoutCurrentYear() {
    return this.isValid() ? `${this.dayTwoSymbols}.${this.monthTwoSymbols}${this.isCurrentYear ? '' : `.${this.yearTwoSymbols}`}` : '...';
  }
  /** Output example: '01.03.2024' */
  get dateWithFullYear() {
    return this.isValid() ? `${this.dayTwoSymbols}.${this.monthTwoSymbols}.${this.year}` : '...';
  }
  /** Output example: '1 марта 2024' */
  get prettyDate() {
    return this.isValid() ? `${this.day} ${this.declensionMonthName} ${this.year}` : '...';
  }
  /** Output example: '01.03' */
  get shortDate() {
    return this.isValid() ? `${this.dayTwoSymbols}.${this.monthTwoSymbols}` : '...';
  }
  /** Output example: '01МАР' */
  get shortDateUpper() {
    return this.isValid() ? `${this.dayTwoSymbols}${this.shortMonthName.toUpperCase()}` : '...';
  }
  /** Output example: '01МАР24' */
  get shortDateUpperWithYear() {
    return this.isValid() ? `${this.dayTwoSymbols}${this.shortMonthName.toUpperCase()}${this.yearTwoSymbols}` : '...';
  }
  /** Output example: '01.03 00:00' */
  get shortDateWithTime() {
    return this.isValid() ? `${this.dayTwoSymbols}.${this.monthTwoSymbols} ${this.time}` : '...';
  }
  /** Output example: '1 мар 00:00' */
  get prettyDateWithTime() {
    return this.isValid() ? `${this.day} ${this.shortMonthName} ${this.time}` : '...';
  }
  /** Output example: '1 мар 24' */
  get shortPrettyDate() {
    return this.isValid() ? `${this.day} ${this.shortMonthName} ${this.yearTwoSymbols}` : '...';
  }
  /** Output example: '1 мар, пт' */
  get prettyDateWithWeekDay() {
    return this.isValid() ? `${this.day} ${this.shortMonthName}, ${this.shortWeekDayName}` : '...';
  }
  /** Output example: '1 мар' */
  get prettyDateWithoutCurrentYear() {
    return this.isValid() ? `${this.day} ${this.shortMonthName}${this.isCurrentYear ? '' : ` ${this.yearTwoSymbols}`}` : '...';
  }
  /** Output example: 0 */
  get hours() {
    return this.isValid() ? this.client.getHours() : NaN;
  }
  /** Output example: '00' */
  get hoursTwoSymbols() {
    return this.isValid() ? addZero(this.hours) : '00';
  }
  /** Output example: 0 */
  get minutes() {
    return this.isValid() ? this.client.getMinutes() : null;
  }
  /** Output example: '00' */
  get minutesTwoSymbols() {
    return this.isValid() ? addZero(this.minutes) : '00';
  }
  /** Output example: '00:00' */
  get time() {
    return `${this.hoursTwoSymbols}:${this.minutesTwoSymbols}`;
  }
  /** Returns the date uid in the "${DD}${MM}${HH}${mm}" format */
  get uid() {
    return `${this.day}${this.month}${this.hours}${this.minutes}`;
  }
  /** output: { date: { date: '01', month: { value: '03', label: 'Март' }, year: 2024, isValid: true } } */
  toInput(withTime = false) {
    return this.isValid() ? {
      date: Object.assign({
        date: this.dayTwoSymbols,
        month: {
          value: this.monthTwoSymbols,
          label: capitalize(this.longMonthName)
        },
        year: this.year,
        isValid: true
      }, withTime ? {
        time: {
          full: `${this.hoursTwoSymbols}:${this.minutesTwoSymbols}:00`,
          hours: `${this.hoursTwoSymbols}`,
          minutes: `${this.minutesTwoSymbols}`
        }
      } : {})
    } : {};
  }
  /** Output example: '2024-03-01 12:00:00' */
  toServer(withTime = true) {
    return this.isValid() ? `${this.year}-${this.monthTwoSymbols}-${this.dayTwoSymbols}${withTime ? ` ${this.time}:00` : ''}` : '';
  }
  toJSON() {
    return Object.assign({}, this);
  }
}

export { DAY, EN_REGEX, HOUR, List as ListEntity, ListFactory, ListWithPagination as ListWithPaginationEntity, LS as LocalStorageEntity, LocaleWrapper as LocaleWrapperEntity, MILLISECOND, MINUTE, Money as MoneyEntity, Pagination as PaginationEntity, RU_REGEX, RowFactory, SECOND, SuperDate as SuperDateEntity, TRANSLIT, addZero, asyncFor, capitalize, compareDeepObject, convertString, convertToTranslit, copyObject, date02format, dateObjectToDate, dateObjectToString, dateToDateObject, dateToString, debounce, deepCopyObject, downloadFile, downloadFileFromUrl, fromBase64, getDateParts, getFirstDayInMonth, getLastDayInMonth, getMonthDateRange, getMonthName, getObjectPropByString, getTimeInSeconds, getWeekdayName, isArray, isDate, isFalsy, isLessThenYesterday, isNotNull, isNumber, isNumeric, isObject, isString, isValidArray, isValidDate, isValidObject, isValidString, lockScroll, plural, removeEmptyFields, roundToTwoDecimals, schd, secondsToPrettyString, stringToDate, stringToDateObject, stringToFloat, stringToNumber, throttle, timeFormat, timezoneFormat, toBase64, toCamelCase, transformDateToObject, unixToString, unlockScroll };
